var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "batch",
    attrs: {
      "width": "500",
      "mask-closable": false,
      "title": $t("il7c3k4", "选择部门")
    },
    on: {
      "on-cancel": _vm.clean
    },
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_c('div', [_c('div', [_c('B', [_vm._v($t("h5542", "成员"))])], 1), _c('div', {
    staticClass: "batch_item"
  }, [_vm.showUserAdd ? _c('span', {
    staticClass: "bacth_item_text",
    on: {
      "click": function ($event) {
        return _vm.openModal('user');
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-add"
    }
  }), _vm._v(` ${$t("ikz0aw4", "选择成员")} `)], 1) : _c('LineOrgTag', {
    attrs: {
      "list": _vm.scopeList
    },
    on: {
      "change": function ($event) {
        return _vm.openModal('user');
      }
    }
  })], 1)]), _c('div', [_c('div', [_c('B', [_vm._v($t("ygyd4i5", "为成员设置"))])], 1), _c('div', {
    staticClass: "batch_item"
  }, [_vm.showOrgAdd ? _c('Poptip', {
    attrs: {
      "placement": "bottom"
    },
    model: {
      value: _vm.popVisible,
      callback: function ($$v) {
        _vm.popVisible = $$v;
      },
      expression: "popVisible"
    }
  }, [_c('span', {
    staticClass: "bacth_item_text"
  }, [_c('Icon', {
    attrs: {
      "type": "md-add"
    }
  }), _vm._v(` ${$t("bh6vvl8", "选择要设置的信息")} `)], 1), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_c('Button', {
    on: {
      "click": function ($event) {
        return _vm.openModal('pop', 'org');
      }
    }
  }, [_vm._v($t("pgxs2", "部门"))])], 1)])]) : _c('span', [_vm.showMessageAdd ? _c('span', [_c('span', [_vm._v(` ${$t("pgxs2", "部门")} `)]), _c('Divider'), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.openModal('org');
      }
    }
  }, [_vm._v($t("ogvk2", "设置"))])], 1) : _c('LineOrgTag', {
    attrs: {
      "list": _vm.messageScopeList
    },
    on: {
      "change": function ($event) {
        return _vm.openModal('org');
      }
    }
  })], 1)], 1)]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.clean
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.buttonDisabled,
      "loading": _vm.modal.loading
    },
    on: {
      "click": _vm.onCommit
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1), _c('ChangeOrgUser', {
    ref: "ChangeOrgUser",
    attrs: {
      "scopeList": _vm.scopeList,
      "showNotice": false
    },
    on: {
      "change": _vm.onChangeUser
    }
  }), _c('ChangeOrg', {
    ref: "ChangeOrg",
    attrs: {
      "scopeList": _vm.messageScopeList
    },
    on: {
      "change": _vm.onChangeOrg
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };